
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.5 12.32l-6.68-2.07v4.57l1.68 1.25v1.25l-2.93-.82-2.89.82v-1.25l1.64-1.25v-4.57L.68 12.32v-1.64L7.32 6.5V1.93c0-.339.117-.625.352-.86.26-.26.56-.39.898-.39.339 0 .625.13.86.39.26.235.39.521.39.86V6.5l6.68 4.18v1.64z","fill":"currentColor"}})])
          )
        }
      }
    